var React = require('react');

function LensHoodInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m13.02,14.12v12.73s-4.58,3.19-4.58,3.19V10.87s4.58,3.25,4.58,3.25Zm-7.46,19.43h2.88s7.46-5.19,7.46-5.19v-15.73s-7.46-5.31-7.46-5.31l-2.88-.08v26.31Z","key":0}),React.createElement("path",{"d":"m27.36,28.3l3.2-2.66v-10.55s-3.2-2.66-3.2-2.66h-9.25s0,15.86,0,15.86h9.25Zm-6.73-2.52v-10.83s5.82,0,5.82,0l1.59,1.32v8.18s-1.59,1.32-1.59,1.32h-5.82Z","key":1}),React.createElement("rect",{"x":"32.78","y":"15.32","width":"2.52","height":"10.26","key":2})]);
}

LensHoodInline.defaultProps = {"width":"32","height":"32","id":"Warstwa_1","data-name":"Warstwa 1","viewBox":"0 0 40 40"};

module.exports = LensHoodInline;

LensHoodInline.default = LensHoodInline;
